module.exports = __webpack_public_path__ + "static/img/PC-9.4c7ac6b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pcga/PC-9.png
// module id = CepC
// module chunks = 0